import * as types from '../mutation-types.js'

const state = {
  currentCategory: {}
}

const actions = {
  fetchArticleCategory({ commit }, category) {
    commit(types.FETCH_EDIT_ARICLE_CATEGORY_SUCCESS, category)
  }
}

const mutations = {
  [types.FETCH_EDIT_ARICLE_CATEGORY_SUCCESS](state, category) {
    state.currentCategory = category
  }
}

const getters = {
  currentCategory: state => state.currentCategory
}

export default {
  state,
  actions,
  mutations,
  getters
}